import { fromJS } from 'immutable';
import { LOGIN_USER } from '../constants/actions';

export function loginReducer(state = fromJS({}), action) {
    switch (action.type) {
        case LOGIN_USER:
            return state.set('isLoggedIn', true)
                .set('token', action.userData.token)
                .set('userUID', action.userData.userUID)
                .set('accessLevel', action.userData.accessLevel);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/loginReducer.ts